export default __webpack_public_path__ + "static/media/nesto_secure_logo_fr_mobile.49975870.png";